import { useMemo } from 'react';

export const useLogo = () => {
  const dayOfYear = useMemo(() => {
    const now = new Date();
    const start = new Date(now.getFullYear(), 0, 0);
    const diff = now - start;
    const oneDay = 1000 * 60 * 60 * 24;
    return Math.floor(diff / oneDay);
  }, []);

  const isNewYearPeriod = useMemo(() => {
    if (window.location.search?.includes('newYear=1')) {
      return true;
    }
    let min = 365 - 31;
    let max = 3;
    return dayOfYear >= min || dayOfYear <= max;
  }, [dayOfYear]);

  const authLogoUrl = useMemo(() => {
    return isNewYearPeriod
      ? `${process.env.PUBLIC_URL}/auth_logo_ny.svg?v=5`
      : `${process.env.PUBLIC_URL}/auth_logo.svg?v=5`;
  }, [isNewYearPeriod]);

  const smallLogoUrl = useMemo(() => {
    return isNewYearPeriod
      ? `${process.env.PUBLIC_URL}/small_logo_ny.svg?v=5`
      : `${process.env.PUBLIC_URL}/small_logo.svg?v=5`; //
  }, [isNewYearPeriod]);

  const smallLogoImpersonatedUrl = useMemo(() => {
    return `${process.env.PUBLIC_URL}/logo_impersonated.svg?v=5`; //
  }, [isNewYearPeriod]);

  const bigLogoUrl = useMemo(() => {
    return isNewYearPeriod
      ? `${process.env.PUBLIC_URL}/big_logo_ny.svg?v=5`
      : `${process.env.PUBLIC_URL}/big_logo.svg?v=5`;
  }, [isNewYearPeriod]);

  const fullLogoUrl = useMemo(() => {
    return isNewYearPeriod
      ? `${process.env.PUBLIC_URL}/full_logo_ny.svg?v=5`
      : `${process.env.PUBLIC_URL}/full_logo.svg?v=5`;
  }, [isNewYearPeriod]);

  return {
    isNewYearPeriod,
    smallLogoUrl,
    bigLogoUrl,
    authLogoUrl,
    smallLogoImpersonatedUrl,
    fullLogoUrl,
  };
};
